const walletDHLExpress = '38';
const walletHermes = '39';
const walletParcelForce = '68';
const walletShipStation = '26';
const amazonShipping = '80';
const fedexFromParcelCast = '40';
const landmarkGlobal = '70';
const aramexAuByShipStation = '192';
const asendiaShippingManifestToAsendia = '3256';
const australiaPostV2 = '3190';
const canadaPostOneBalance = '127';
const canparOneBalance = '104';
const clientDHLExpress = '145';
const clientDhlEcommerce = '149';
const clientDHLExpressByShipStation = '146';
const clientFedEx = '116';
const clientSharedCarriers = '150';
const clientStampsCom = '109';
const clientUPS = '117';
const colissimoOneBalance = '191';
const couriersPleaseByShipStation = '161';
const demoOauthCarrier = '142';
const dhlEcommerceByShipStation = '196';
const dhlExpressGermanyOneBalance = '1013';
const dhlExpressOneBalance = '195';
const doordashByShipsation = '151';
const dPDGermanyOneBalance = '1135';
const dummyCarrier = '1000';
const dummyModule = '2681';
const dummyWalletedCarrier = '1001';
const fedExOneBalance = '194';
const globalPostByoa = '3258';
const gLSGermanyOneBalance = '1139';
const purolatorCanadaOneBalance = '128';
const sekoLtlByShipStation = '105';
const sendleByShipStation = '147';
const swyftOneBalance = '1134';
const uberByShipStation = '143';
const yodelByShipStation = '3357';

export const excludedCarriers = [
  walletDHLExpress,
  walletHermes,
  walletParcelForce,
  walletShipStation,
  amazonShipping,
  fedexFromParcelCast,
  landmarkGlobal,
  aramexAuByShipStation,
  asendiaShippingManifestToAsendia,
  australiaPostV2,
  canadaPostOneBalance,
  canparOneBalance,
  clientDHLExpress,
  clientDhlEcommerce,
  clientDHLExpressByShipStation,
  clientFedEx,
  clientSharedCarriers,
  clientStampsCom,
  clientUPS,
  colissimoOneBalance,
  couriersPleaseByShipStation,
  demoOauthCarrier,
  dhlEcommerceByShipStation,
  dhlExpressGermanyOneBalance,
  dhlExpressOneBalance,
  doordashByShipsation,
  dPDGermanyOneBalance,
  dummyCarrier,
  dummyModule,
  dummyWalletedCarrier,
  fedExOneBalance,
  globalPostByoa,
  gLSGermanyOneBalance,
  purolatorCanadaOneBalance,
  sekoLtlByShipStation,
  sendleByShipStation,
  swyftOneBalance,
  uberByShipStation,
  yodelByShipStation,
];
